<template>
  <nav>
    <div class="navbar">
      <img style="height: 40px;" src="/favicon.ico" alt="Logo Our Transfert"/>
      <router-link class="navbar-element" to="/">Accueil</router-link>
      <router-link class="navbar-element" to="/send">Envoyer</router-link>
      <router-link class="navbar-element" to="/manage">Gérer</router-link>
    </div>
  </nav>

  <div class="page-container">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Impact', sans-serif
}

nav {
  width: 100%;
  display: flex;
  justify-content: center;
}

.navbar {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 3rem;
  gap: 2rem;
  background-color: #323336;
  border-radius: 30px;
  z-index: 1000;
}

.navbar-element {
  position: relative;
  font-size: 1.5rem;
  color: #CC0000;
  text-decoration: none;
}

.navbar-element::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 2px;
  background-color: #CC0000;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.navbar-element:hover::after {
  transform: scaleX(1);
}

.page-container {
  padding-top: 70px;
  text-align: center;
}
</style>
